(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/create-team/assets/javascripts/create-team.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/create-team/assets/javascripts/create-team.js');
"use strict";

const {
  DebounceInputV2
} = svs.lb_ui.debounceInput;
const CreateTeam = _ref => {
  let {
    children,
    onTeamNameChange,
    title,
    subtitle,
    backendError,
    validationError,
    isLoading,
    isSubmittable,
    label,
    onHandleSubmit,
    teamName,
    infoMessage,
    inputHelpText,
    inverted
  } = _ref;
  const teamNameCtrlGrpClasses = ['control-group'].concat(backendError || validationError ? 'error' : '').join(' ');
  const handleFormKeyDown = e => {
    if (!validationError) {
      e.stopPropagation();
    }
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (!validationError && isSubmittable && !isLoading) {
      onHandleSubmit(teamName);
    }
  };
  return React.createElement("section", {
    "aria-labelledby": "create-team-title",
    className: "create-team ".concat(inverted ? 'create-team-inverted' : '')
  }, React.createElement("h2", {
    className: "f-800",
    id: "create-team-title"
  }, title), React.createElement("p", null, subtitle), React.createElement("form", {
    onKeyDown: handleFormKeyDown,
    onSubmit: handleSubmit
  }, React.createElement("div", {
    className: teamNameCtrlGrpClasses
  }, React.createElement(DebounceInputV2, {
    autoComplete: "off",
    disabled: isLoading,
    errorMessage: validationError || backendError,
    hasError: Boolean(validationError || backendError),
    id: "team-name",
    infoMessage: infoMessage,
    inputHelpText: inputHelpText,
    inverted: inverted,
    label: label,
    maxLength: "30",
    name: "teamname",
    onChange: _ref2 => {
      let {
        target
      } = _ref2;
      onTeamNameChange(target.value);
    },
    type: "text",
    value: teamName
  })), children));
};
setGlobal('svs.components.marketplaceShared.createTeam.CreateTeam', CreateTeam);

 })(window);